import styles from './styles.module.css';

function ContagemEstoque() {
	return (
		<section>
			<div className={styles.container}>
				<h1>Termos de uso</h1>
				<p>
					Por favor, leia com atenção os termos e condições.
					<br />
					<br />
					Ao instalar o Contagem Estoque você ESTÁ DE ACORDO COM AS CONDIÇÕES E
					TERMOS estabelecidos. E permite o armazenamento dos dados necessários
					para contemplar a relação (maiores informações sobre os dados, por
					favor, consultar a politica de privacidade). Note que a recusa destes
					Termos do Website impedirá que você utilize algumas funções do
					aplicativo.
				</p>

				<h2>1. Serviços oferecidos</h2>
				<p>
					1.1 Este TERMO se aplica para regular o uso do serviço oferecido pelo
					Contagem Estoque aos USUÁRIOS, qual seja, possibilitar que USUÁRIOS
					leiam códigos de barra para gerar uma lista do produto e a sua
					quantidade em estoque, possibilitando a exportação dessa lista para
					planilhas ou para o sitema Gestores.
					<br />
					<br />
					1.2 O serviço do Contagem Estoque consiste, portanto, em automatizar o
					processo de gerenciamento de estoque.
				</p>

				<h2>2. Cadastro</h2>
				<p>
					2.1 O App não exige que o USUÁRIO realize cadastro ou login de
					qualquer tipo para utilizar as funções descritas no item 1.
				</p>

				<h2>3. Obrigações do usuário</h2>
				<p>
					3.1 É obrigação do USUÁRIO fornecer as permissões necessárias para o
					funcionamento do aplicativo.
				</p>

				<h2>4. Obrigações do Contagem Estoque</h2>
				<p>
					4.1 Disponibilizar espaço virtual que permita ao USUÁRIO executar a
					função de criar contagem de estoque.
				</p>

				<h2>5. Modificações deste termo</h2>
				<p>
					5.1 O presente TERMO DE USO poderá, a qualquer tempo, ter seu
					conteúdo, ou parte dele, modificados para adequações e inserções, tudo
					com vistas ao aprimoramento dos serviços disponibilizados.
				</p>

				<h2>6. Permissões obrigatórias</h2>
				<ul>
					<li>CAMERA</li>
				</ul>

				<h2>7. Aceitação do termo de uso</h2>
				<p>
					7.1 O USUÁRIO declara ter lido, entendido e que aceita todas as
					regras, condições e obrigações estabelecidas no presente TERMO.
				</p>
			</div>
		</section>
	);
}

export default ContagemEstoque;
